import axios from '../../v2/app/services/axiosService';

export default {
  async getServices() {
    const response = await axios.get(`/api/pricing/services`);
    return response.data;
  },
  async getService(serviceID) {
    const response = await axios.get(`/api/pricing/services/${serviceID}`);
    return response.data;
  },
  async getPlans(params = {}) {
    const options = {
      params,
    };
    const response = await axios.get(`/api/pricing/plans`, options);
    return response.data;
  },
  async getPlansForService(serviceID) {
    const response = await axios.get(`/api/pricing/services/${serviceID}/plans`);
    return response.data;
  },
  async getPlan(planID) {
    const response = await axios.get(`/api/pricing/plans/${planID}`);
    return response.data;
  },
  async changePlan(planID) {
    const form = {
      plan_id: planID,
    };
    const response = await axios.post(`/api/plans/change`, form);
    return response.data;
  }
}
